import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { postSalesforceFormDataToEloqua } from 'api/SalesforceOnboardingForm';

export const salesforceApi = createApi({
  reducerPath: 'salesforceApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api' }),
  endpoints: (build) => ({
    submitForm: build.mutation<boolean, any>({
      query: (formData) => ({
        url: '/forms/submitcase',
        method: 'POST',
        body: formData,
        validateStatus: (response) => response.status === 200,
      }),
    }),
    submitFormToEloqua: build.mutation<boolean, { url: string; data: any }>({
      queryFn: async ({ url, data }) => {
        try {
          const response = await postSalesforceFormDataToEloqua(url, data);
          return response.status === 200 ? response.data : { error: response.statusText };
        } catch (e) {
          return { error: e };
        }
      },
    }),
  }),
});

export const { useSubmitFormMutation, useSubmitFormToEloquaMutation } = salesforceApi;
